import React from 'react'
import { Typography, makeStyles, Grid, Container} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems:'center',
        [theme.breakpoints.down('sm')]:{
            
            marginTop:'30px'
        },
        // backgroundColor:'red'
    },
    sectionHeading: {
        fontSize: '72px',
        fontWeight: 600,
        letterSpacing: 0.1,
        margin: '20px 0px',
        lineHeight: '60px',
        [theme.breakpoints.down('md')]:{
            fontSize: '60px',
        },
        [theme.breakpoints.down('sm')]:{
            fontSize: '48px',
            lineHeight: '40px',
            marginTop:'30px'
        }
    },
    note1:{
        margin: '15px 10px 10px 20px',
        fontWeight:600
    },
    note2:{
        color: theme.palette.secondary.dark,
        marginLeft: '20px',
        fontSize: '24px',
        fontWeight:'500'
    },
    exploreBtn:{
        color: 'black',
        marginLeft: '20px',
        boxShadow: 'none',
        borderRadius: 2,
        padding: '10px 75px',
        margin: '20px 0',
        '&:hover':{
            color: theme.palette.secondary.light
        }
    },
    writerImg:{
        width: '100%',
        margin: '0 auto'
    },
    writerInfo: {
        margin: '12px 0 30px 0'
    }
}))

function AssociatedWriters() {
    const classes = useStyles()
    return (
        <div className={classes.root}>
            <Container>
                <h2 className={classes.sectionHeading}>Associated Writers</h2>
                <p style={{marginBottom:'40px'}}>Competently iterate team building potentialities and team driven alignments. Appropriately enhance cost effective web-readiness for sticky collaboration and idea-sharing. Collaboratively disseminate cross functional collaboration and idea-sharing without</p>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <img src="./assets/images/asso-1.png" alt="Ass_writer" className={classes.writerImg}/>
                        <Typography variant="h6" className={classes.writerInfo}>Interactively Productize Team</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <img src="./assets/images/asso-2.png" alt="Ass_writer" className={classes.writerImg}/>
                        <Typography variant="h6" className={classes.writerInfo}>Interactively Productize Team</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <img src="./assets/images/asso-3.png" alt="Ass_writer" className={classes.writerImg}/>
                        <Typography variant="h6" className={classes.writerInfo}>Interactively Productize Team</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <img src="./assets/images/asso-4.png" alt="Ass_writer" className={classes.writerImg}/>
                        <Typography variant="h6" className={classes.writerInfo}>Interactively Productize Team</Typography>
                    </Grid>

                </Grid>
            </Container>
            
        </div>
    )
}

export default AssociatedWriters
